/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeagueTemplateList = {
    type: 'array',
    contains: {
        type: 'LeagueTemplate',
    },
} as const;
